import { get, hash } from "@ember/helper";
import ConditionalLoadingSpinner from "discourse/components/conditional-loading-spinner";
import DButton from "discourse/components/d-button";
import LoadMore from "discourse/components/load-more";
import PluginOutlet from "discourse/components/plugin-outlet";
import bodyClass from "discourse/helpers/body-class";
import hideApplicationFooter from "discourse/helpers/hide-application-footer";
import lazyHash from "discourse/helpers/lazy-hash";
import { i18n } from "discourse-i18n";
import CirclesCard from "../../components/circles/card";
import SearchFieldCustom from "../../components/circles/search-fields/custom";
import SearchFieldDropdown from "../../components/circles/search-fields/dropdown";
import TextSearchField from "../../components/circles/search-fields/text";

const CirclesIndex = <template>
  {{bodyClass "circles-browser-page"}}

  {{#if this.circles.canLoadMore}}
    {{hideApplicationFooter}}
  {{/if}}

  <section>
    <div class="circles-browser-navigation-header">
      <PluginOutlet
        @name="circles-browser-navigation-header"
        @outletArgs={{lazyHash
          controller=@controller
          isUserProfile=@controller.isUserProfile
        }}
      >
        <div class="circles-browser-navigation-filters">
          <PluginOutlet
            @name="circles-browser-navigation-filters"
            @outletArgs={{lazyHash
              controller=@controller
              isUserProfile=@controller.isUserProfile
            }}
          >
            <TextSearchField
              class="circles-search-filter-name"
              @placeholder={{i18n "discourse_circles.index.filter"}}
              @controller={{@controller}}
              @filter={{lazyHash
                name="filter"
                queryParameter="filter"
                type="text"
              }}
              @value={{@controller.filter}}
            />

            {{#each @controller.filters as |filter|}}
              {{filter.field_type}}
              <SearchFieldCustom
                @controller={{@controller}}
                @filter={{filter}}
                @value={{get @controller filter.queryParameter}}
              />
            {{/each}}

            {{#if @controller.isFilteringByTypeEnabled}}
              <SearchFieldDropdown
                @controller={{@controller}}
                @none={{hash
                  name=(i18n "discourse_circles.index.all.title")
                  description=(i18n "discourse_circles.index.all.description")
                }}
                @filter={{hash
                  name="type"
                  queryParameter="type"
                  type="dropdown"
                  options=@controller.types
                }}
                @nameProperty="name"
                @valueProperty="id"
                @value={{@controller.type}}
              />
            {{/if}}

            {{#if @controller.totalRows}}
              <div class="circles-browser-navigation-filters__result-count">
                {{i18n
                  "discourse_circles.index.total_rows"
                  count=@controller.totalRows
                }}
              </div>
            {{/if}}
          </PluginOutlet>
        </div>
        <div class="circles-browser-navigation-actions">
          <PluginOutlet
            @name="circles-browser-navigation-actions"
            @outletArgs={{lazyHash
              controller=@controller
              isUserProfile=@controller.isUserProfile
            }}
          >
            {{#if @controller.showNewCircleButton}}
              <DButton
                @action={{@controller.newCircle}}
                @icon="plus"
                @label="discourse_circles.new.title"
                class="circles-new-button btn-default"
              />
            {{/if}}
          </PluginOutlet>
        </div>
      </PluginOutlet>
    </div>

    <ConditionalLoadingSpinner @condition={{@controller.isLoading}}>
      {{#if @controller.hasCircles}}
        <LoadMore
          @selector=".circles-boxes .circles-card"
          @action={{@controller.loadMore}}
        >
          <div class="container">
            <div class="circles-boxes">
              {{#each @controller.circles.content as |circle|}}
                <CirclesCard @model={{circle}} @showMembershipButton={{true}} />
              {{/each}}
            </div>
          </div>
        </LoadMore>

        <ConditionalLoadingSpinner
          @condition={{@controller.circles.loadingMore}}
        />
      {{else}}
        {{#if @controller.filter}}
          <p class="circles-not-found">
            {{i18n "discourse_circles.index.not_found"}}
          </p>
        {{else}}
          <p class="circles-empty">
            {{i18n "discourse_circles.index.empty"}}
          </p>
        {{/if}}
      {{/if}}
    </ConditionalLoadingSpinner>
  </section>
</template>;

export default CirclesIndex;
